import AppTooltip from "../../elements/AppTooltip";
import { Link, useParams } from "react-router-dom";

const CloudSettingsLink = () => {
  const { tenantID }: any = useParams();

  return (
    <Link
      to={`/clouds/${tenantID}/settings/home`}
      className="nav-link cursor-pointer pr-0 ml--2"
    >
      <AppTooltip useTooltip content={"Cloud Settings"}>
        <span className="avatar avatar-sm rounded text-capitalize text-center link-hovered bg-white text-secondary">
          <i
            className="mdi mdi-cog"
            style={{
              fontSize: "24px",
              position: "relative",
              top: 1,
            }}
          ></i>
        </span>
      </AppTooltip>
    </Link>
  );
};

export default CloudSettingsLink;
